module.exports = __webpack_public_path__ + "img/nzidoo-logo.b10ddcad.png";